import { DIRECTION_LABEL, STATUS_LABEL } from './cashTracker';

export const EMPTY_COLUMN_FILTERS = {
  date: '',
  direction: '',
  entity: '',
  counterparty: '',
  category: '',
  amount: '',
  status: '',
  note: '',
};

function norm(value) {
  return String(value ?? '').trim().toLowerCase();
}

function includes(haystack, needle) {
  const q = norm(needle);
  if (!q) return true;
  return norm(haystack).includes(q);
}

function digits(value) {
  return String(value ?? '').replace(/[^\d]/g, '');
}

export function hasActiveColumnFilters(filters) {
  return Object.values(filters || {}).some((value) => String(value ?? '').trim() !== '');
}

export function itemMatchesColumnFilters(item, filters, { categoryLabel, amountText, dateText } = {}) {
  const f = filters || {};
  if (f.date) {
    const hit = includes(item?.date, f.date)
      || includes(dateText || '', f.date);
    if (!hit) return false;
  }
  if (f.direction && !includes(DIRECTION_LABEL[item?.direction] || item?.direction, f.direction)) return false;
  if (!includes(item?.entity, f.entity)) return false;
  if (!includes(item?.counterparty, f.counterparty)) return false;
  if (!includes(categoryLabel || item?.categoryKey, f.category)) return false;
  if (f.amount) {
    const raw = String(item?.amount ?? '');
    const formatted = amountText || raw;
    const qDigits = digits(f.amount);
    const hit = includes(formatted, f.amount)
      || includes(raw, f.amount)
      || (qDigits && digits(raw).includes(qDigits));
    if (!hit) return false;
  }
  if (f.status && !includes(STATUS_LABEL[item?.status] || item?.status, f.status)) return false;
  if (!includes(`${item?.note || ''} ${item?.documentName || ''}`, f.note)) return false;
  return true;
}

export function filterCashItems(items, filters, lookup = {}) {
  if (!hasActiveColumnFilters(filters)) return items || [];
  return (items || []).filter((item) => itemMatchesColumnFilters(item, filters, {
    categoryLabel: lookup.categoryLabel?.(item),
    amountText: lookup.amountText?.(item),
    dateText: lookup.dateText?.(item),
  }));
}

/**
 * Signed net of ledger rows: inflows +, outflows −.
 * Used for the filtered transaction table Total row.
 */
export function sumCashItemsNet(items) {
  return (items || []).reduce((sum, item) => {
    const amount = Number(item?.amount);
    if (!Number.isFinite(amount) || amount <= 0) return sum;
    return sum + (item.direction === 'in' ? amount : -amount);
  }, 0);
}
